import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Checkboxes } from "../../../FlowConfigurationInputs";
import FormControl from "@material-ui/core/FormControl";
import { MenuItem, Select } from "@material-ui/core";
import { TextInput } from '../../../FlowConfigurationInputs/TextInput/NewTextInput';

/**
 * @Description this page AI Library Action Configuration Form
 * @Param       action - object
 * @Param       variables - object variable list
 * @Param       setOpenVariable - open variable function that allows us to open
 * @Param       variableRender - variable render
 * @Returns     div element
 * @Author      Kerem Karadeniz
 */
function SortArray({ action, variables, setOpenVariable }) {
    const { t } = useTranslation();
    const label = "CONTENT.CONFIGURATION-FORM.PRE-PROCESSING.";
    const [output, setOutput] = useState("");
    const options = {
        checkboxes: { label: label + "TRUNCATE" },
        checkboxesSecond: { label: label + "KEEP-EMPTY-CHUNKS" },
    };

    // set localtype initial value
    useEffect(() => {
        if (!action.fields.outputAs) {
            action.fields.outputAs = { value: "" };
        } else {
            setOutput(action.fields.outputAs.value);
        }
    }, [variables, action]);

    // set selected local type
    function handleLocalType(event) {
        setOutput(event.target.value);
        action.fields.outputAs.value = event.target.value;
    }

    return (
        <div>
            <div className="form-element">
                Input  {t(label + "COLUMN")}
                <TextInput
                    action={action}
                    inputName="inputOrder"
                    variables={variables}
                    setOpenVariable={setOpenVariable}
                    isRequired={true}
                />
            </div>
            <div className="form-element">
                Mode
                <FormControl variant="outlined" fullWidth style={{ width: "90%" }}>
                    <Select
                        value={output}
                        onChange={handleLocalType}
                    >
                        <MenuItem value="NUMERICALORDER">
                            Numerical Order
                        </MenuItem>
                        <MenuItem value="ALPHABETICALORDER">Alphabetical Order</MenuItem>
                    </Select>
                </FormControl>
            </div>
            <div className="form-element">
                <Checkboxes
                    action={action}
                    options={options.checkboxes}
                    inputName="descendingOrder"
                    isRequired={false}
                />
            </div>
            <div className="form-element">
                Output column(empty for in-place)
                <TextInput
                    action={action}
                    inputName="outputColumn"
                    variables={variables}
                    setOpenVariable={setOpenVariable}
                    isRequired={false}
                />
            </div>
        </div>
    );
}

export default SortArray;